import React, { Component } from 'react';

class Hideable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: this.props.expanded,
    };
  }

  expandContractHandler = (e) => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const { title, children } = this.props;
    const expandedClass = this.state.expanded ? 'react-sanfona-item-expanded' : '';
    const rootClass = `react-sanfona-item ${expandedClass}`;
    const bodyStyles = {
      display: this.state.expanded ? 'block' : 'none',
    };
    return (
      <div className={rootClass}>
        <div onClick={this.expandContractHandler}>{title}</div>
        <div className="react-sanfona-item-body" style={bodyStyles}>
          <div className="react-sanfona-item-body-wrapper">{children}</div>
        </div>
      </div>
    );
  }
}

export default Hideable;
